import type { PublicChatTheme } from './types';

export const firstTheme: PublicChatTheme = {
  name: 'crimson',
  container: {
    background: 'bg-crimson-gradient',
    wrapper: 'size-full overflow-hidden',
    // Transparent so the container gradient shows through.
    backdrop: 'bg-transparent',
  },
  text: {
    // High-contrast copy
    primary: 'text-[#AEF3E7]',
    // Secondary copy tint
    secondary: 'text-[#8EE3EF]/60',
    // Accent (buttons/interactive)
    accent: 'text-[#C33C54]',
  },
  header: {
    title: 'text-[#AEF3E7]',
    subtitle: 'text-[#8EE3EF]',
    // Dot/badge accent
    badge: 'bg-[#C33C54]',
  },
  bubbles: {
    // User: Rosewood gradient
    user: 'glass-bubble bg-gradient-to-br from-[#C33C54] to-[#a02b40] backdrop-blur-none md:backdrop-blur-md rounded-24 max-w-[417px] border border-[#C33C54]/50',
    // AI: Cerulean surface
    ai: 'glass-bubble bg-[#37718E]/90 backdrop-blur-sm rounded-24 max-w-[636px] border border-[#8EE3EF]/20',
    // System: Yale Blue band
    system: 'rounded-2xl bg-[#254E70] text-center',
    // Text styles and colors
    textUser: 'font-sans text-14 font-medium leading-160 tracking-neg-2 xl:text-18 text-[#AEF3E7]',
    textAi: 'font-sans text-14 font-medium leading-160 tracking-neg-2 xl:text-18 text-[#AEF3E7]',
    // Timestamps
    timestampUser: 'text-[#AEF3E7]/70',
    timestampAi: 'text-[#8EE3EF]/60',
  },
  input: {
    wrapper: '',
    field: 'text-[#AEF3E7] placeholder:text-[#8EE3EF]/50 bg-transparent',
    placeholder: 'text-[#8EE3EF]/50',
    button: 'text-[#C33C54] hover:text-[#AEF3E7]',
    buttonIcon: 'text-current',
  },
  branding: {
    text: 'text-[#8EE3EF]/60',
    // Filter to turn logo into Icy Aqua (#AEF3E7)
    logoFilter:
      'brightness(0) saturate(100%) invert(88%) sepia(21%) saturate(552%) hue-rotate(97deg) brightness(99%) contrast(90%)',
  },
};
